import { ComplianceType, UploadedDocument } from "@/types"

export const isCompleted = (type: ComplianceType, complianceDocuments: UploadedDocument[]) => {
  if (type === ComplianceType.NDA) {
    return complianceDocuments.some(doc => doc.name.toLowerCase().includes("eso mutual nda"))
  } else if (type === ComplianceType.BACKGROUND_CHECK) {
    return complianceDocuments.some(doc => doc.name.toLowerCase().includes("background check permission form"))
  }
  return false
}
